import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';

import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
    selector: 'lib-remove-button',
    standalone: true,
    imports: [CommonModule, IconButtonComponent],
    templateUrl: './remove-button.component.html',
    styleUrl: './remove-button.component.css'
})
export class RemoveButtonComponent {
    /* eslint-disable */
    @Output() onClick: EventEmitter<any | null> = new EventEmitter<any | null>();

    onButtonClick() {
        this.onClick.emit();
    }
}
